import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const FormGraficoPizza = ({ dados }) => {
    const valores = dados[0];

    const data = {
        labels: ['Automática', 'Automática com Alteração', 'Manual'],
        datasets: [
            {
                label: 'Entradas',
                data: [
                    valores.ENTRADA_AUTOMATICA,
                    valores.ENTRADA_AUTOMATICA_ALT,
                    valores.ENTRADA_MANUAL
                ],
                backgroundColor: ['#4CAF50', '#8BC34A', '#BDBDBD'],
                borderWidth: 1
            }
        ]
    };

    const options = {
        plugins: {
            legend: {
                position: 'bottom'
            },
            datalabels: {
                formatter: (value, context) => {
                    const total = context.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                    const percentage = ((value / total) * 100).toFixed(1) + '%';
                    return percentage;
                },
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: 14
                }
            }
        },
        maintainAspectRatio: false
    };

    return (
        <div style={{ width: '100%', height: 300, textAlign: 'center' }}>
            <Doughnut data={data} options={options} />
        </div>
    );
};

export default FormGraficoPizza;
